import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlockAppointment, LazyBlockBanner, LazyBlockBlogList, LazyBlockBookingWizard, LazyBlockCampaignBanner, LazyBlockChecklist, LazyBlockConsultationForm, LazyBlockContact, LazyBlockCredentials, LazyBlockCtaBanner, LazyBlockDoctorIntro, LazyBlockEventRegistration, LazyBlockFaq, LazyBlockFeatures, LazyBlockFlashSale, LazyBlockFooter, LazyBlockGallery, LazyBlockHeader, LazyBlockHero, LazyBlockHighlights, LazyBlockInsurance, LazyBlockLandingHero, LazyBlockLeadCalculator, LazyBlockLeadChatWidget, LazyBlockLeadMagnet, LazyBlockLeadQuiz, LazyBlockLeadSurvey, LazyBlockNewsletterCapture, LazyBlockPersonalizedGuide, LazyBlockProducts, LazyBlockReasons, LazyBlockServiceGroups, LazyBlockServices, LazyBlockSmartContactForm, LazyBlockSpecialties, LazyBlockSpinWheel, LazyBlockTeam, LazyBlockTestimonials, LazyBlockWaitlistForm, LazyBookingFlowNav, LazyBookingFlowSteps, LazyBookingRequestModal, LazyBookingTicket, LazyLeadFlowShell, LazyLeadQuestionFields, LazyServicePricingCard, LazyBuilderAddBlockModal, LazyBuilderAddPageModal, LazyBuilderBlockAppointmentEditor, LazyBuilderBlockBannerEditor, LazyBuilderBlockBlogListEditor, LazyBuilderBlockBookingWizardEditor, LazyBuilderBlockCampaignBannerEditor, LazyBuilderBlockChecklistEditor, LazyBuilderBlockConsultationFormEditor, LazyBuilderBlockContactEditor, LazyBuilderBlockCredentialsEditor, LazyBuilderBlockCtaBannerEditor, LazyBuilderBlockDoctorIntroEditor, LazyBuilderBlockEditorPanel, LazyBuilderBlockEventRegistrationEditor, LazyBuilderBlockFaqEditor, LazyBuilderBlockFeaturesEditor, LazyBuilderBlockFlashSaleEditor, LazyBuilderBlockFooterEditor, LazyBuilderBlockGalleryEditor, LazyBuilderBlockHeaderEditor, LazyBuilderBlockHeroEditor, LazyBuilderBlockHighlightsEditor, LazyBuilderBlockInsuranceEditor, LazyBuilderBlockLandingHeroEditor, LazyBuilderBlockLeadCalculatorEditor, LazyBuilderBlockLeadChatWidgetEditor, LazyBuilderBlockLeadMagnetEditor, LazyBuilderBlockLeadQuizEditor, LazyBuilderBlockLeadSurveyEditor, LazyBuilderBlockListItem, LazyBuilderBlockNewsletterCaptureEditor, LazyBuilderBlockPersonalizedGuideEditor, LazyBuilderBlockProductsEditor, LazyBuilderBlockReasonsEditor, LazyBuilderBlockServiceGroupsEditor, LazyBuilderBlockServicesEditor, LazyBuilderBlockSmartContactFormEditor, LazyBuilderBlockSpecialtiesEditor, LazyBuilderBlockSpinWheelEditor, LazyBuilderBlockTeamEditor, LazyBuilderBlockTestimonialsEditor, LazyBuilderBlockWaitlistFormEditor, LazyBuilderBottomSheet, LazyBuilderCanvas, LazyBuilderImageUploadInput, LazyBuilderLanguageManager, LazyBuilderLeadToolEditor, LazyBuilderMobileTabBar, LazyBuilderPostSaveConfirm, LazyBuilderSidebar, LazyBuilderTopBar, LazyAppColorModeToggle, LazyAppConfirmModal, LazyAppDataTable, LazyAppEmptyState, LazyAppFormCard, LazyAppJalaliCalendar, LazyAppMobileTabBar, LazyAppMoneyInput, LazyAppPageHeader, LazyAppPanelShell, LazyAppStatCard, LazyAppToolbar, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["BlockAppointment", LazyBlockAppointment],
["BlockBanner", LazyBlockBanner],
["BlockBlogList", LazyBlockBlogList],
["BlockBookingWizard", LazyBlockBookingWizard],
["BlockCampaignBanner", LazyBlockCampaignBanner],
["BlockChecklist", LazyBlockChecklist],
["BlockConsultationForm", LazyBlockConsultationForm],
["BlockContact", LazyBlockContact],
["BlockCredentials", LazyBlockCredentials],
["BlockCtaBanner", LazyBlockCtaBanner],
["BlockDoctorIntro", LazyBlockDoctorIntro],
["BlockEventRegistration", LazyBlockEventRegistration],
["BlockFaq", LazyBlockFaq],
["BlockFeatures", LazyBlockFeatures],
["BlockFlashSale", LazyBlockFlashSale],
["BlockFooter", LazyBlockFooter],
["BlockGallery", LazyBlockGallery],
["BlockHeader", LazyBlockHeader],
["BlockHero", LazyBlockHero],
["BlockHighlights", LazyBlockHighlights],
["BlockInsurance", LazyBlockInsurance],
["BlockLandingHero", LazyBlockLandingHero],
["BlockLeadCalculator", LazyBlockLeadCalculator],
["BlockLeadChatWidget", LazyBlockLeadChatWidget],
["BlockLeadMagnet", LazyBlockLeadMagnet],
["BlockLeadQuiz", LazyBlockLeadQuiz],
["BlockLeadSurvey", LazyBlockLeadSurvey],
["BlockNewsletterCapture", LazyBlockNewsletterCapture],
["BlockPersonalizedGuide", LazyBlockPersonalizedGuide],
["BlockProducts", LazyBlockProducts],
["BlockReasons", LazyBlockReasons],
["BlockServiceGroups", LazyBlockServiceGroups],
["BlockServices", LazyBlockServices],
["BlockSmartContactForm", LazyBlockSmartContactForm],
["BlockSpecialties", LazyBlockSpecialties],
["BlockSpinWheel", LazyBlockSpinWheel],
["BlockTeam", LazyBlockTeam],
["BlockTestimonials", LazyBlockTestimonials],
["BlockWaitlistForm", LazyBlockWaitlistForm],
["BookingFlowNav", LazyBookingFlowNav],
["BookingFlowSteps", LazyBookingFlowSteps],
["BookingRequestModal", LazyBookingRequestModal],
["BookingTicket", LazyBookingTicket],
["LeadFlowShell", LazyLeadFlowShell],
["LeadQuestionFields", LazyLeadQuestionFields],
["ServicePricingCard", LazyServicePricingCard],
["BuilderAddBlockModal", LazyBuilderAddBlockModal],
["BuilderAddPageModal", LazyBuilderAddPageModal],
["BuilderBlockAppointmentEditor", LazyBuilderBlockAppointmentEditor],
["BuilderBlockBannerEditor", LazyBuilderBlockBannerEditor],
["BuilderBlockBlogListEditor", LazyBuilderBlockBlogListEditor],
["BuilderBlockBookingWizardEditor", LazyBuilderBlockBookingWizardEditor],
["BuilderBlockCampaignBannerEditor", LazyBuilderBlockCampaignBannerEditor],
["BuilderBlockChecklistEditor", LazyBuilderBlockChecklistEditor],
["BuilderBlockConsultationFormEditor", LazyBuilderBlockConsultationFormEditor],
["BuilderBlockContactEditor", LazyBuilderBlockContactEditor],
["BuilderBlockCredentialsEditor", LazyBuilderBlockCredentialsEditor],
["BuilderBlockCtaBannerEditor", LazyBuilderBlockCtaBannerEditor],
["BuilderBlockDoctorIntroEditor", LazyBuilderBlockDoctorIntroEditor],
["BuilderBlockEditorPanel", LazyBuilderBlockEditorPanel],
["BuilderBlockEventRegistrationEditor", LazyBuilderBlockEventRegistrationEditor],
["BuilderBlockFaqEditor", LazyBuilderBlockFaqEditor],
["BuilderBlockFeaturesEditor", LazyBuilderBlockFeaturesEditor],
["BuilderBlockFlashSaleEditor", LazyBuilderBlockFlashSaleEditor],
["BuilderBlockFooterEditor", LazyBuilderBlockFooterEditor],
["BuilderBlockGalleryEditor", LazyBuilderBlockGalleryEditor],
["BuilderBlockHeaderEditor", LazyBuilderBlockHeaderEditor],
["BuilderBlockHeroEditor", LazyBuilderBlockHeroEditor],
["BuilderBlockHighlightsEditor", LazyBuilderBlockHighlightsEditor],
["BuilderBlockInsuranceEditor", LazyBuilderBlockInsuranceEditor],
["BuilderBlockLandingHeroEditor", LazyBuilderBlockLandingHeroEditor],
["BuilderBlockLeadCalculatorEditor", LazyBuilderBlockLeadCalculatorEditor],
["BuilderBlockLeadChatWidgetEditor", LazyBuilderBlockLeadChatWidgetEditor],
["BuilderBlockLeadMagnetEditor", LazyBuilderBlockLeadMagnetEditor],
["BuilderBlockLeadQuizEditor", LazyBuilderBlockLeadQuizEditor],
["BuilderBlockLeadSurveyEditor", LazyBuilderBlockLeadSurveyEditor],
["BuilderBlockListItem", LazyBuilderBlockListItem],
["BuilderBlockNewsletterCaptureEditor", LazyBuilderBlockNewsletterCaptureEditor],
["BuilderBlockPersonalizedGuideEditor", LazyBuilderBlockPersonalizedGuideEditor],
["BuilderBlockProductsEditor", LazyBuilderBlockProductsEditor],
["BuilderBlockReasonsEditor", LazyBuilderBlockReasonsEditor],
["BuilderBlockServiceGroupsEditor", LazyBuilderBlockServiceGroupsEditor],
["BuilderBlockServicesEditor", LazyBuilderBlockServicesEditor],
["BuilderBlockSmartContactFormEditor", LazyBuilderBlockSmartContactFormEditor],
["BuilderBlockSpecialtiesEditor", LazyBuilderBlockSpecialtiesEditor],
["BuilderBlockSpinWheelEditor", LazyBuilderBlockSpinWheelEditor],
["BuilderBlockTeamEditor", LazyBuilderBlockTeamEditor],
["BuilderBlockTestimonialsEditor", LazyBuilderBlockTestimonialsEditor],
["BuilderBlockWaitlistFormEditor", LazyBuilderBlockWaitlistFormEditor],
["BuilderBottomSheet", LazyBuilderBottomSheet],
["BuilderCanvas", LazyBuilderCanvas],
["BuilderImageUploadInput", LazyBuilderImageUploadInput],
["BuilderLanguageManager", LazyBuilderLanguageManager],
["BuilderLeadToolEditor", LazyBuilderLeadToolEditor],
["BuilderMobileTabBar", LazyBuilderMobileTabBar],
["BuilderPostSaveConfirm", LazyBuilderPostSaveConfirm],
["BuilderSidebar", LazyBuilderSidebar],
["BuilderTopBar", LazyBuilderTopBar],
["AppColorModeToggle", LazyAppColorModeToggle],
["AppConfirmModal", LazyAppConfirmModal],
["AppDataTable", LazyAppDataTable],
["AppEmptyState", LazyAppEmptyState],
["AppFormCard", LazyAppFormCard],
["AppJalaliCalendar", LazyAppJalaliCalendar],
["AppMobileTabBar", LazyAppMobileTabBar],
["AppMoneyInput", LazyAppMoneyInput],
["AppPageHeader", LazyAppPageHeader],
["AppPanelShell", LazyAppPanelShell],
["AppStatCard", LazyAppStatCard],
["AppToolbar", LazyAppToolbar],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
